export default __webpack_public_path__ + "static/media/side-msg-icon.5aac8077.svg";